import { render, staticRenderFns } from "./EstablishmentRoleChangeActivationType.vue?vue&type=template&id=f0ae4c9a&"
import script from "./EstablishmentRoleChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./EstablishmentRoleChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports